import { render } from "./NavigationComp.vue?vue&type=template&id=976978ec&scoped=true"
import script from "./NavigationComp.vue?vue&type=script&lang=js"
export * from "./NavigationComp.vue?vue&type=script&lang=js"

import "./NavigationComp.vue?vue&type=style&index=0&id=976978ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-976978ec"]])

export default __exports__